import React from "react";
import { SkeletonLoader } from "@activecollab/components";
import PropTypes from "prop-types";

export const VersionDescriptionLoader = ({ className }) => {
  return (
    <div className={className}>
      <SkeletonLoader
        as="div"
        data-testid="loader1"
        className="tw-mb-6 tw-h-[19px]"
      />
      <SkeletonLoader
        as="div"
        data-testid="loader2"
        className="tw-w-3/4 tw-mb-6  tw-h-[19px]"
      />
      <SkeletonLoader
        as="div"
        data-testid="loader3"
        className="tw-w-1/2  tw-h-[19px]"
      />
    </div>
  );
};

VersionDescriptionLoader.propTypes = {
  className: PropTypes.string,
};

VersionDescriptionLoader.defaultProps = {
  loading: true,
};
